const seriesIdentity = (series) => {
  if (!series) return '';
  return String(
    series.seriesInstanceUID ||
    series.series_instance_uid ||
    series.series_uid ||
    series.id ||
    ''
  );
};

const wlIdentity = (wl) => {
  if (!wl) return { ww: null, wc: null };
  return {
    ww: Number.isFinite(Number(wl.ww)) ? Number(wl.ww) : null,
    wc: Number.isFinite(Number(wl.wc)) ? Number(wl.wc) : null,
  };
};

export const getViewportLayoutIdentity = ({
  studyInstanceUID = '',
  role = '',
  layout = null,
  preloaded = [],
  slotWLs = [],
  slotLabels = [],
} = {}) => JSON.stringify({
  studyInstanceUID: String(studyInstanceUID || ''),
  role: String(role || ''),
  layout: layout ? {
    rows: Number(layout.rows) || 0,
    cols: Number(layout.cols) || 0,
    label: String(layout.label || ''),
    geometry: layout.geometry || null,
  } : null,
  slots: (preloaded || []).map((series, index) => ({
    series: seriesIdentity(series),
    wl: wlIdentity(slotWLs[index]),
    label: String(slotLabels[index] || ''),
  })),
});

export default getViewportLayoutIdentity;
